module.exports = __webpack_public_path__ + "img/login-bg.3aecb459.jpg";